export const SECOND = 1000;
export const MINUTE = 60 * SECOND;

export const NOTIFICATION_REFRESH_TIME = 2 * MINUTE;
export const FETCH_BUILD_DETAILS_TIME = 2 * MINUTE;

export const SYSTEM_ALERT_DEFAULT_TIME = 5 * SECOND;
export const SYSTEM_ALERT_REGISTER_TIME = MINUTE;
export const SYSTEM_ALERT_ERROR_TIME = 10 * SECOND;
